
import React, { useState, useEffect, useContext } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";
import Loader from "../components/loader";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";

import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SessionPopup from "./SessionPopup";

import { ToastContainer } from "react-toastify";

import { toast } from "react-toastify";


let { lambda, appname } = window.app

const TransactionData = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    const [transactions, setTransactions] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);


    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    // const [sortDirection, setSortDirection] = useState('asc');
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);


    // Fe tch transaction history and set data
    const fetchTransactionHistory1 = async (params) => {
        setIsLoading(true);
        // debugger
        try {
            let response = await tmdbApi.fetchTransactionHistory1(params);
            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
                setIsLoading(false);
                // localStorage.clear();
                // navigate("/");
            } else {
                let res = (response?.result ?? []).sort((a, b) => {
                    const dateA = new Date(a?.created || 0);
                    const dateB = new Date(b?.created || 0);
                    return dateB - dateA;
                });

                setTransactions(res);
                setData(res);
            }
        } catch (err) {
            setTableErrMsg(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = async () => {
        setIsLoading(true);
        try {
            let response = await tmdbApi.fetchTransactionHistory1(null);
            if (response?.data?.result === "Invalid token or Expired") {
                // localStorage.clear();
                // navigate("/");
                setShowSessionPopupup(true)
            } else {
                setTransactions(response?.data?.result ?? []);
                setData(response?.data?.result ?? []);
            }
        } catch (err) {
            setTableErrMsg(true);
        } finally {
            setIsLoading(false);
        }
    }

    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    // Transaction columns
    const columns = [
        {
            name: 'Transaction ID',
            selector: row => row?.transactionId ?? row?._id ?? '',
            sortable: true,
        },
        {
            name: 'Plan Type',
            selector: row => row?.duration ?? row?.duration ?? '',
            sortable: true,
        },
        {
            name: 'Amount',
            selector: row => row?.amount ?? row?.price ?? '',
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row?.date ?? row?.created,
            sortable: true,
            cell: (props) => props?.date ? dateFormat(props?.date) : (props?.created ? dateFormat(props?.created) : ''),
        },
        {
            name: 'Status',
            selector: row => row?.status ?? '',
            sortable: true,
        },
    ];

    const dateFormat = (created) => {
        const date = new Date(created);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };






    useEffect(() => {
        if (searchedFlag) {
            handleSearch();
        } else {
            fetchTransactionHistory1(null);
        }

    }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }



    const handleChange = (e) => {
        if (e.target.value === "") {
            //   transactionInfo();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };




    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }




    // exportToExcel(modifiedArray, "data");


    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        console.log('data22222--->', data)
    }

    const clearSearch = () => {
        setStartDate(null);
        setEndDate(null);
        setUserSearch("");
        GetTimeActivity()
        fetchTransactionHistory1(null)
        setcurrentPage(1);
    }
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    // const handleDateSearch = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);
    //     try {
    //         let params = {};
    //         if (usersearch) params.search = usersearch;
    //         if (startDate) params.searchedFrom = moment(startDate).format("YYYY-MM-DD");
    //         if (endDate) params.searchedTo = moment(endDate).format("YYYY-MM-DD");
    //         let response = await tmdbApi.fetchTransactionHistory1(params);
    //         if (response?.result === "Invalid token or Expired") {
    //             // localStorage.clear();
    //             // navigate("/");
    //              setShowSessionPopupup(true)
    //         } else {
    //             setTransactions(response?.result ?? []);
    //             setData(response?.result ?? []);
    //         }
    //     } catch (err) {
    //         console.log(err);
    //         setTableErrMsg(true);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }

    const handleDateSearch = async (e) => {
        e.preventDefault();

        const inputQuery = usersearch;

        // ✅ Block only when NOTHING is provided
        if (
            inputQuery.trim().length === 0 &&
            !startDate &&
            !endDate
        ) {
            toast.error("Search field cannot be empty.");
            return;
        }

        setIsLoading(true);

        try {
            let params = {};

            if (inputQuery.trim().length > 0) {
                params.search = inputQuery.trim();
            }

            if (startDate) {
                params.searchedFrom = moment(startDate).format("YYYY-MM-DD");
            }

            if (endDate) {
                params.searchedTo = moment(endDate).format("YYYY-MM-DD");
            }

            const response = await tmdbApi.fetchTransactionHistory1(params);

            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true);
            } else {
                setTransactions(response?.result ?? []);
                setData(response?.result ?? []);
            }
        } catch (err) {
            console.log(err);
            setTableErrMsg(true);
        } finally {
            setIsLoading(false);
        }
    };


    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }
    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}

            <div id="layout-wrapper" className="transactionList-mod-res">
                <Header />
                <SideMenu />

                {/* Start right Content here  */}

                <div className="main-content user-management transctions-table" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">Transactions</h4>
                                        </div>

                                        {/* <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser} id="add-user-btn">
                                                ADD USER
                                            </button>
                                        </div> */}


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> : <>
                                                <div className="row mb-2" id="table-header-row">
                                                    <div className="col-sm-4 button-block" id="button-block">
                                                        <div className="dataTables_length" id="datatable-length">

                                                            {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                          onClick={handleExport} id="export-btn">
                          <span className="material-icons">north_east</span>Export
                      </button> */}


                                                        </div>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <div className="search-box mb-2 d-inline-block" id="search-box">
                                                            <div className="position-relative">
                                                                {/* <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={usersearch}
                                                                    onChange={(e) => handleChange(e)}
                                                                    placeholder="Search by Name"
                                                                    onKeyPress={handleKeypress}
                                                                    id="search-input"
                                                                /> */}
                                                                {/* <button
                                                                    className="fill_btn"
                                                                    onClick={(e) => handleSearch(e, "normalsearch")}
                                                                    id="search-btn">
                                                                    <span className="material-icons search-icon">search</span>
                                                                </button> */}
                                                            </div>
                                                            {/* Date Range Filter */}
                                                            <div className="d-flex me-2">
                                                                <div className="d-flex">
                                                                    <DatePicker
                                                                        selected={startDate}
                                                                        onChange={date => setStartDate(date)}
                                                                        selectsStart
                                                                        startDate={startDate}
                                                                        endDate={endDate}
                                                                        placeholderText="Start Date"
                                                                        className="form-control start-date"
                                                                        dateFormat="dd-MM-yyyy"
                                                                        isClearable
                                                                    />
                                                                    <DatePicker
                                                                        selected={endDate}
                                                                        onChange={date => setEndDate(date)}
                                                                        selectsEnd
                                                                        startDate={startDate}
                                                                        endDate={endDate}
                                                                        minDate={startDate}
                                                                        placeholderText="End Date"
                                                                        className="form-control end-date"
                                                                        dateFormat="dd-MM-yyyy"
                                                                        isClearable
                                                                    />
                                                                </div>
                                                                <div className="dataTables_length" id="datatable-length-reset">
                                                                    <button
                                                                        className="fill_btn search-trans-btn"
                                                                        onClick={(e) => handleDateSearch(e)}
                                                                        id="search-btn">
                                                                        <span className="material-icons search-icon">search</span>
                                                                    </button>
                                                                </div>


                                                            </div>
                                                            <div className="dataTables_length" id="datatable-length-reset">
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={clearSearch}
                                                                    id="reset-btn">
                                                                    <span className="material-icons-outlined">sync</span>Reset
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="text-sm-end" id="text-end"></div>
                                                    </div>

                                                </div>

                                                <DataTable
                                                    key={keyForRerender}
                                                    columns={columns}
                                                    keyField='_id'
                                                    data={data}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    responsive
                                                    persistTableHead
                                                    striped
                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={data?.length}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={rowsPerPage}
                                                    paginationDefaultPage={currentPageNew}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                    sortFunction={customSort}
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}
                                                    // progressPending={isLoading}
                                                    // progressComponent={<TableLoader />}
                                                    id="data-table"
                                                />
                                            </>}


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>

                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />




                    <Footer id="footer" />
                </div>




            </div>
        </>
    );
};

export default TransactionData;